import * as powerbiModels from 'powerbi-models';
import { Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { ReportService } from '@sb-shared/services/report.service';
import { take } from 'rxjs/operators';

declare var powerbi: any;

@Component({
    selector: 'sb-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnChanges, OnDestroy {

  @Input() reportId: number;
  @Input() action: string;

  @ViewChild('reportContainer', { static: false }) reportContainer: ElementRef;

  private reportInstance: any = null;

  constructor(private reportService: ReportService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reportId?.currentValue) {
      this.loadReportConfig(changes.reportId.currentValue);
    }

    if (changes.action?.currentValue) {
      switch (changes.action.currentValue) {
        case 'print':    this.print(); break;
        case 'refresh':  this.refresh(); break;
        case 'fullScreen': this.fullScreen(); break;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.reportInstance !== null && this.reportContainer?.nativeElement) {
      powerbi.reset(this.reportContainer.nativeElement);
    }
  }

  private loadReportConfig(reportId: number): void {
    this.reportService.getReportConfig(reportId)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          if (!this.reportContainer?.nativeElement) return;

          const config = {
            type: 'report',
            tokenType: powerbiModels.TokenType.Embed,
            accessToken: data.embedToken.token,
            embedUrl: data.embedUrl,
            id: data.Id,
            permissions: powerbiModels.Permissions.Read,
            settings: {
              filterPaneEnabled: true,
              navContentPaneEnabled: true
            }
          };

          if (this.reportInstance !== null) {
            powerbi.reset(this.reportContainer.nativeElement);
          }

          this.reportInstance = powerbi.embed(this.reportContainer.nativeElement, config);
          window.dispatchEvent(new Event('resize'));
        },
        error: (err: any) => console.error(err)
      });
  }

  private print(): void {
    this.reportInstance?.print();
  }

  private refresh(): void {
    this.reportInstance?.reload();
  }

  private fullScreen(): void {
    this.reportInstance?.fullscreen();
  }
}
